import {Component, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {BasePageComponent} from "../../../base/components/base-page.component";
import {UsersService} from "../../../shared/services/users.service";
import {ClientAccountService} from "../../../shared/services/client-account.service";
import {StorageService} from "../../../core/services/storage.service";
import {AccountModel} from "../../../shared/models/account.model";
import {CustomerModel} from "../../../shared/models/customer.model";
import {FeaturesService} from "../../../shared/services/features.service";
import {FeaturesResearchModel} from "../../../shared/models/features-research.model";
import {FeaturesResearchFilterModel} from "../../../shared/models/features-research-filter.model";
import {ConfigurationService} from "../../../shared/services/configuration.service";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss'],
})
export class HomeDashboardComponent extends BasePageComponent {

  isAccountSelected: boolean;
  client: CustomerModel;
  account: AccountModel;
  accounts: Array<AccountModel> = [];
  isButtonVisible: boolean;

  constructor(injector: Injector, public userService: UsersService, public storageService: StorageService,
              public clientAccountService: ClientAccountService, public featuresService: FeaturesService,
              public configurationService: ConfigurationService) {
    super(injector);
  }

  ngOnDestroyForChildren(): void {
  }

  ngOnInitForChildren(): void {
    this.account = this.clientAccountService.getAccount();
    this.client = this.clientAccountService.getClient();

    if (this.account) {
      this.isAccountSelected = true;
    } else {
      this.isAccountSelected = false;
    }
    this.clientAccountService.getAccounts(this.client.customerCode).subscribe((res: Array<AccountModel>) => {
      this.accounts = res;
    });
  }

  pageName(): string {
    return "HomeDashboardComponent";
  }

  redirectToResa(accountCode: string) {
    window.open(`${this.configurationService.configuration.external.resa.reseller}${accountCode}?unit=${accountCode}`, "_blank");
  }

  accessAccount(account: AccountModel) {
    this.clientAccountService.setAccount(account);
    this.isAccountSelected = true;
  }
}
